export default __webpack_public_path__ + "static/media/resultgrading.2644570f.png";